import { RefObject } from 'react';

export const dispatchFormSubmit = (formRef: RefObject<HTMLFormElement>) => {
  formRef.current && formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
};
